export function removeNonDigits(input) {
    return input.replace(/\D/g, '');
}
